/* eslint-disable no-unused-vars, @typescript-eslint/no-unused-vars */
/* global __webpack_public_path__ */

// eslint-disable-next-line no-global-assign
__webpack_public_path__ = `${Gaia.staticURL}js/bundles/`;

// We aspire for GaiaCloud to support every browser supported by Mapbox GL JS
// https://docs.mapbox.com/help/troubleshooting/mapbox-browser-support/#mapbox-gl-js

// https://caniuse.com/#feat=promises
import {polyfill} from 'es6-promise';
import {hydrate} from 'react-dom';
import React from 'react';

polyfill();

// https://caniuse.com/#feat=mdn-javascript_builtins_symbol_asynciterator
import 'es6-symbol/implement';

// https://caniuse.com/#search=asynciterator
if (Symbol['asyncIterator'] === undefined) {
    Symbol.asyncIterator = Symbol.for('asyncIterator');
}

window.gaiaReactServerHydrate = (Component, props) => {
    document.getElementById('react-server-temporary-style').remove();
    hydrate(<Component {...props} />, document.getElementById('react-server-html'));
};

// We call `window.trackAnalytics` in some html templates
import trackAnalytics from '../utils/gaia/trackAnalytics';
import trackFormAnalytics from '../utils/gaia/trackFormAnalytics';
import trackRevenueAnalytics from '../utils/gaia/trackRevenueAnalytics';

window.trackAnalytics = trackAnalytics;
window.trackFormAnalytics = trackFormAnalytics;
window.trackRevenueAnalytics = trackRevenueAnalytics;

if (/Android/i.test(navigator.userAgent)) {
    appendStylesheet('.hide-if-android {display: none;}');
}

// https://stackoverflow.com/questions/9038625/detect-if-device-is-ios/9039885#9039885
if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
    appendStylesheet('.hide-if-ios {display: none;}');
}

function appendStylesheet(body) {
    const styleEl = document.createElement('style');
    document.head.appendChild(styleEl);
    styleEl.type = 'text/css';
    styleEl.appendChild(document.createTextNode(body));
}
